// extracted by mini-css-extract-plugin
export default {"managementWrapper":"userManagement_managementWrapper__SeBpH","managementTitle":"userManagement_managementTitle__IRzky","nothing":"userManagement_nothing__S8LIR"};